import clsx from "clsx";

/** Props Interface */
interface TimelineLineProps {
	withoutLine?: boolean;
	renderItemMarker?: (() => React.ReactNode) | undefined;
}

export function TimelineLine({ withoutLine, renderItemMarker }: TimelineLineProps) {
	/** Render */
	return (
		<div
			className="relative flex flex-col items-center max-w"
			style={{
				contentVisibility: "auto",
			}}
		>
			{!withoutLine && (
				<div className="left-[50%] absolute border-color border-r-[0.5px] w-0 h-full translate-x-[-50%]" />
			)}
			{renderItemMarker ? (
				<div
					className={clsx(
						"top-0 sticky",
						"flex-center",
						"card",
						"p-0.5 w-7 aspect-square",
						"rounded-base",
						"relative",
						"z-10",
						"shadow-xs card-bg border-[0.5px] border-color",
					)}
				>
					{renderItemMarker?.()}
				</div>
			) : null}
		</div>
	);
}
